export default __webpack_public_path__ + "static/media/keyvisual-ksk-dusseldorf.c379ee18.jpg";